import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class InitialEstimate extends Field {
  static subqueriesForModel() {
    return { initialEstimate: ['text'] };
  }

  get title() {
    return 'Initial estimate';
  }

  exampleContents(): FieldContentsData {
    return { text: '5d', icon: { name: 'fa-regular fa-clock' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.initialEstimate?.text) {
      return {
        text: record.initialEstimate.text,
        icon: { name: 'fa-regular fa-clock' },
      };
    }

    return {};
  }
}
